import React from "react";

import PeriodType from "./PeriodType";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";

const paperPadding = 2;
const enterToolTipDelay = 400;

type PeriodToggleGroupProps = {
  period: PeriodType;
  setPeriod: (historicalPeriod: PeriodType) => void;
  periodArray?: PeriodType[];
  isFuture?: boolean;
};

const PeriodArray: PeriodType[] = ["Max", "2 Yr", "1 Yr", "YTD"];

function periodOptionToTooltip(period_option: PeriodType, isFuture: boolean) {
  if (isFuture) {
    if (period_option === "Max") {
      return "Chart all available future values.";
    }
    if (period_option === "Y/E") {
      return "Chart values until year-end.";
    }
    return `Chart values for next ${period_option.toLowerCase().replace("yr", "year")} period.`;
  } else {
    if (period_option === "Max") {
      return "Chart all available historical values.";
    }
    if (period_option === "YTD") {
      return "Chart values from the start of the year.";
    }
    return `Chart values from last ${period_option.toLowerCase().replace("yr", "year")} period.`;
  }
}

function PeriodToggleGroup(props: PeriodToggleGroupProps) {
  return (
    <ToggleButtonGroup // TODO: fix the spacing on this?
      value={props.period}
      exclusive
      onChange={(e, newValue) => {
        if (newValue && newValue !== props.period) {
          props.setPeriod(newValue);
          // props.updateOverviewGraph();
        }
      }}
      sx={{
        px: paperPadding,
      }}
    >
      {(props.periodArray || PeriodArray).map((period_option, index) => (
        <Tooltip
          key={index}
          title={periodOptionToTooltip(period_option, props.isFuture || false)}
          placement="top-start"
          arrow
          enterDelay={enterToolTipDelay}
        >
          <ToggleButton value={period_option} selected={props.period === period_option} sx={{ whiteSpace: "nowrap" }}>
            {period_option}
          </ToggleButton>
        </Tooltip>
      ))}
    </ToggleButtonGroup>
  );
}
export default PeriodToggleGroup;
